import { useBlockProps, RichText } from '@wordpress/block-editor';

export default function save(props) {
	const blockProps = useBlockProps.save({
		className: 'c4l-key-concept',
	});
	const { attributes } = props;
	const { content } = attributes;

	return (
		<div {...blockProps}>
			<RichText.Content
				tagName='div'
				className='c4l-key-concept-content'
				value={content}
			/>
		</div>
	);
}
